import axios from "axios";

export default function PartneraddressFormService(formData, method, partnerId, addressId) {
  let url = process.env.REACT_APP_API_HOST + "/partnerAddress/" + partnerId
  if(addressId) url = process.env.REACT_APP_API_HOST + "/partnerAddress/" + partnerId + "/" + addressId
  return axios({
    method: method,
    url: url,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
